import { render, staticRenderFns } from "./ProductExtras.vue?vue&type=template&id=718109b1"
import script from "./ProductExtras.vue?vue&type=script&lang=js"
export * from "./ProductExtras.vue?vue&type=script&lang=js"
import style0 from "./ProductExtras.vue?vue&type=style&index=0&id=718109b1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports